export interface Language {
  language_gb_sn: string
  language_nm: string
  language_kor_nm: string
  language_native_nm: string
}

export default function () {
  async function fetchLanguages() {
    return await useAPI<Language[]>('/language/languages/all', {
      method: 'GET',
    })
  }

  async function fetchServiceLanguages(): Promise<{
    language_gb_sn: string
    language_nm: string
    language_kor_nm: string
    language_native_nm: string
  }[]> {
    const data = await fetch(`https://napi.watv.org/language/WATV_HEAVENLYMOTHERSLOVE?gubun=UI&isService=1`, {
      method: 'GET',
    })

    const serviceLangauges = await data.json()
    return serviceLangauges
  }

  return {
    fetchLanguages,
    fetchServiceLanguages,
  }
}
